<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="status === 'create'">
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon>
        เพิ่มโปรโมชัน
      </v-card-title>
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="status === 'edit'">
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon>
        แก้ไขโปรโมชัน
      </v-card-title>
      <v-card color="#FAFAFA" class="ml-3" outlined rounded elevation="0">
        <v-form ref="form" lazy-validation>
          <v-card-text>
            <!-- ข้อมูลทั่วไป -->
            <v-row>
              <h2 class="pt-1 ml-2 mt-2 mb-4 font16">ข้อมูลทั่วไป</h2>
              <v-spacer style="border-top: 1px solid #E6E6E6; margin-top: 24px; margin-left: 14px;"></v-spacer>
              <v-btn icon outlined style="border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" class="mt-1"><v-icon color="#27AB9C">mdi-file-document-outline</v-icon></v-btn>
            </v-row>
            <!-- ประเภทโปรโมชัน -->
            <v-row>
              <v-col col="5" md="2" class="font16_400 pr-0">
                <span>ประเภทโปรโมชัน  :</span>
              </v-col>
              <v-col col="7" md="9" class="font16_400 pl-0">
                <v-text-field v-model="promotion_type" outlined dense hide-details readonly disabled></v-text-field>
              </v-col>
            </v-row>
            <!-- เพิ่มรูปภาพโปรโมชัน -->
            <v-row>
              <v-col class="font16">เพิ่มรูปภาพโปรโมชัน</v-col>
              <v-col cols="12" md="12">
                <v-card elevation="0" width="100%" height="100%" style="background: #FFFFFF; border-radius: 8px;">
                  <v-card-text>
                    <v-card height="300px" elevation="0" style="border: 2px dashed #27AB9C; box-sizing: border-box; border-radius: 8px;" @click="onPickFile()">
                      <v-card-text>
                        <v-row no-gutters align="center" justify="center" style="cursor: pointer;">
                          <v-file-input
                            v-model="DataImage"
                            :items="DataImage"
                            accept="image/jpeg, image/jpg, image/png"
                            @click="event => event.target.value = null"
                            @change="UploadImage()"
                            id="file_input"
                            :clearable="false"
                            style="display:none">
                          </v-file-input>
                          <v-col cols="12" md="12" class="mb-6">
                            <v-row justify="center" class="pt-10">
                              <v-img
                                src="@/assets/ImageINET-Marketplace/ICONShop/uploadImg.png"
                                width="280.34"
                                height="154.87"
                                contain
                              ></v-img>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row justify="center" align="center">
                              <v-col cols="12" md="12" style="text-align: center;">
                                <span style="line-height: 24px; font-weight: 400;" :style="MobileSize ? 'font-size: 14px;' : 'font-size: 16px;'">เพิ่มรูปภาพของคุณที่นี่</span><br/>
                                <span style="line-height: 24px; font-weight: 400;" :style="MobileSize ? 'font-size: 14px;' : 'font-size: 16px;'">หรือเลือกรูปภาพจากคอมพิวเตอร์ของคุณ</span><br/>
                                <span style="line-height: 16px; font-weight: 400;" :style="MobileSize ? 'font-size: 9px;' : 'font-size: 12px;'">(ไฟล์นามสกุล .JPG, .JPEG, .PNG)</span><br/>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    <div v-if="promotion_image.length !== 0" class="mt-4">
                      <draggable v-model="promotion_image"  :move="onMove" @start="drag=true" @end="drag=false" class="pl-5 pr-5 row  fill-height align-center sortable-list">
                        <v-col v-for="(item, index) in promotion_image" :key="index" cols="12" md="3">
                          <v-card outlined class="pa-1" width="146" height="146" v-if="status !== 'edit'">
                            <v-img :src="item.path" :lazy-src="item.path" width="136" height="136" contain>
                              <v-btn icon x-small style="float: right; background-color: #ff5252;">
                                <v-icon x-small color="white" dark @click="RemoveImage(index, item)">mdi-close</v-icon>
                              </v-btn>
                            </v-img>
                          </v-card>
                          <v-card outlined class="pa-1" width="146" height="146" v-else-if="status === 'edit'">
                            <v-img :src="item.path" :lazy-src="item.path" width="136" height="136" contain>
                              <v-btn icon x-small style="float: right; background-color: #ff5252;">
                                <v-icon x-small color="white" dark @click="RemoveImage(index, item)">mdi-close</v-icon>
                              </v-btn>
                            </v-img>
                          </v-card>
                        </v-col>
                      </draggable>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- ชื่อโปรโมชัน -->
            <v-row class="font16">
              <v-col cols="12">ชื่อโปรโมชัน <span style="color: red;">*</span></v-col>
              <v-col cols="12" class="py-0">
                <v-text-field v-model="promotion_name" :rules="Rules.name" :maxLength="30" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <!-- ซื้อแถม -->
            <v-row :class="MobileSize ? 'font16 ma-0' : 'font16 mt-6 ml-4'">
              <v-col cols="6" md="5" class="mt-2">
                <v-row>
                  <v-col cols="6" md="3" align="end" class="pa-0">ซื้อ <span style="color: red;" class="mr-1">*</span></v-col>
                  <v-col cols="6" md="" class="pa-0">
                    <v-text-field v-model="promotion_buy" :rules="Rules.promotionBuy" @input="checkpromotionBuy()" type="number" outlined dense oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" md="5" class="mt-2">
                <v-row>
                  <v-col cols="6" md="4" align="end" class="pa-0">แถม <span style="color: red;" class="mr-1">*</span></v-col>
                  <v-col cols="6" md="" class="pa-0">
                    <v-form ref="FormPromotionFree">
                      <v-text-field v-model="promotion_free" :rules="Rules.free" type="number" outlined dense oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- ระยะเวลาใช้งาน -->
            <v-row class="font16">
              <v-col class="pb-0">ระยะเวลาใช้งาน <span style="color: red;">*</span></v-col>
              <v-col cols="12" class="py-0" align="center">
                <v-radio-group v-model="date" :rules="Rules.input" row class="pa-0 ma-0 font16">
                  <v-radio color="#27AB9C" label="กำหนด" value="yes"></v-radio>
                  <v-radio color="#27AB9C" label="ไม่กำหนด" value="no"></v-radio>
                </v-radio-group>
              </v-col>
              <v-card width="100%" style="border: 1px solid #27AB9C;" :class="MobileSize ? 'ma-2 pa-4' : 'ma-2 ml-10 pa-4'" v-if="date === 'yes'" outlined elevation="0">
                <v-row>
                  <v-col col="5" md="4">วันที่เริ่ม</v-col>
                  <v-col cols="1" md="1"></v-col>
                  <v-col cols="5" md="4" :style="{color: noEndTime === true ? '#9A9A9A' : ''}">วันที่สิ้นสุด</v-col>
                </v-row>
                <!-- เวลาเริ่ม - สิ้นสุด -->
                <v-row dense>
                  <!-- เวลาเริ่ม -->
                  <v-col col="4" md="4" class="ma-0 pa-0">
                    <v-dialog
                      ref="dialogStartDateKeepCupon"
                      v-model="modalStartDate"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="promotion_startDate"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          dense
                          placeholder="DD/MM/YYYY"
                          :rules="Rules.date"
                        ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                      </template>
                      <v-date-picker
                        color="#27AB9C"
                        v-model="selectDateStart"
                        scrollable
                        flat
                        :min="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString()"
                      >
                        <v-row dense>
                          <v-col cols="12" class="pt-0">
                            <v-menu
                              ref="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="promotion_startTime"
                                  readonly
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mt-2"
                                ><v-icon slot="append" color="#27AB9C">mdi-clock-time-four-outline </v-icon></v-text-field>
                              </template>
                              <v-time-picker
                                color="#27AB9C"
                                v-model="promotion_startTime"
                                full-width
                                format="24hr"
                                :min="minTimeStart"
                                @click:minute="$refs.menu.save(promotion_startTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" align="end">
                            <v-btn text color="primary" @click="modalStartDate = false" > Cancel </v-btn>
                            <v-btn text color="primary" @click="saveStartDate(selectDateStart, promotion_startTime)"> OK</v-btn>
                          </v-col>
                        </v-row>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="1" md="1" align="center" class="ma-0 pa-0 mt-2">ถึง</v-col>
                  <!-- เวลาสิ้นสุด -->
                  <v-col col="4" md="4" class="ma-0 pa-0">
                    <v-dialog
                      ref="dialogEndDateKeepCupon"
                      v-model="modalEndDate"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="promotion_endDate"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                          :disabled="promotion_startDate === '' || noEndTime === true ? true : false"
                          placeholder="DD/MM/YYYY"
                          :rules="Rules.dateEnd"
                        ><v-icon slot="append" :color="promotion_startDate === '' || noEndTime === true ? '9A9A9A' : '#27AB9C'">mdi-calendar </v-icon></v-text-field>
                      </template>
                      <v-date-picker
                        color="#27AB9C"
                        v-model="selectDateEnd"
                        scrollable
                        flat
                        :min="selectDateStart"
                      >
                        <v-row dense>
                          <v-col cols="12" class="pt-0">
                            <v-menu
                              ref="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="promotion_endTime"
                                  readonly
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mt-2"
                                ><v-icon slot="append" color="#27AB9C">mdi-clock-time-four-outline </v-icon></v-text-field>
                              </template>
                              <v-time-picker
                                color="#27AB9C"
                                v-model="promotion_endTime"
                                full-width
                                format="24hr"
                                :min="minTimeEnd"
                                @click:minute="$refs.menu.save(promotion_endTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" align="end">
                            <v-btn text color="primary" @click="modalEndDate = false" > Cancel </v-btn>
                            <v-btn text color="primary" @click="saveEndDate(selectDateEnd, promotion_endTime)"> OK</v-btn>
                          </v-col>
                        </v-row>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
                <!-- ไม่มีเวลาสิ้นสุด -->
                <v-row dense>
                  <v-checkbox v-model="noEndTime" label="ไม่ระบุวันที่สิ้นสุด" color="#27AB9C" hide-details></v-checkbox>
                </v-row>
              </v-card>
            </v-row>
            <!-- กำหนดจำนวนและสิทธิ์ -->
            <v-row class="font16">
              <v-col class="pb-0">กำหนดจำนวนและสิทธิ์ <span style="color: red;">*</span></v-col>
              <v-col cols="12" class="py-0" align="center">
                <v-radio-group v-model="number" :rules="Rules.input" row class="pa-0 ma-0 font16">
                  <v-radio color="#27AB9C" label="กำหนด" value="yes"></v-radio>
                  <v-radio color="#27AB9C" label="ไม่กำหนด" value="no"></v-radio>
                </v-radio-group>
              </v-col>
              <v-card width="100%" style="border: 1px solid #27AB9C;" :class="MobileSize ? 'ma-2 pa-4' : 'ma-2 ml-10 pa-4'" v-if="number === 'yes'" outlined elevation="0">
                <v-col cols="12" class="pa-0">
                  <p class="my-0">จำนวนที่ใช้ได้ <span style="color: red;">*</span></p>
                  <v-text-field v-model="promotion_available" :rules="Rules.limit_amount" @input="checkAvilable()" type="number" outlined dense></v-text-field>
                </v-col>
                <v-radio-group v-model="promotion_benefit" :rules="Rules.input"  class="pa-0 font16">
                  <v-radio color="#27AB9C" label="1 ลูกค้าต่อ 1 สิทธิ์การใช้งาน" value="1"></v-radio>
                  <v-radio color="#27AB9C" label="ไม่จำกัดสิทธิ์การใช้งาน" value="0"></v-radio>
                  <v-radio color="#27AB9C" label="กำหนดเอง" value="2"></v-radio>
                </v-radio-group>
                <v-row dense class="ml-1" v-if="promotion_benefit === '2'">
                  <p class="mt-2"> 1 ลูกค้า ต่อ</p>
                  <v-col :cols="IpadProSize || IpadSize ? 8 : MobileSize ? 7 : 6" class="ma-0">
                    <v-form ref="FormPromotionOwnBenefit">
                      <v-text-field v-model="promotion_ownBenefit" type="number" :rules="Rules.promotion_ownBenefit" outlined dense>
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <p class="mt-2">สิทธิ์</p>
                </v-row>
              </v-card>
            </v-row>
            <!-- เลือกกลุ่มลูกค้าที่สามารถใช้โปรโมชันได้ -->
            <v-row class="font16">
              <v-col cols="12" md="12" class="pb-0">เลือกกลุ่มลูกค้าที่สามารถใช้โปรโมชันได้ <span style="color: red;">*</span></v-col>
              <v-col cols="12" md="12" sm="12">
                <v-select
                  v-model = promotion_channel
                  :items = channelList
                  item-text="channel_name"
                  item-value="channel_id"
                  placeholder = "เลือกกลุ่มลูกค้า"
                  class="py-0"
                  :rules="Rules.channel"
                  chips multiple outlined dense
                >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="selectAllTier()"
                  >
                    <v-list-item-action>
                      <v-icon :color="channelList.length > 0 ? '#27AB9C' : ''">
                        {{icon}}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        ทุกกลุ่มคู่ค้า
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters justify="end" align="end" class="mt-4 mb-5">
              <v-btn dense  dark outlined color="#27AB9C" class="pl-10 pr-10" @click="CancelSave()">ยกเลิก</v-btn>
              <v-btn color="#27AB9C" elevation="0" dark class="ml-4 pl-10 pr-10" id="confirmcreateproduct" @click="save()" style="color: white; font-size: 16px; font-weight: 700; line-height: 24px;">บันทึก</v-btn>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
// import { Decode } from '@/services'
export default {
  data () {
    return {
      seller_shop_id: '',
      status: '',
      promotion_id: '',
      // ประเภทโปรโมชัน
      promotion_type: 'ซื้อ X ชิ้น แถม Y ชิ้น',
      // รูปภาพโปรโมชัน
      promotion_changeImage: 'n',
      promotion_image: [],
      DataImage: [],
      // ชื่อโปรโมชัน
      promotion_name: '',
      // ซื้อแถม
      promotion_buy: '',
      promotion_free: '',
      // ระยะเวลาใช้งาน
      date: '',
      // เวลาเริ่ม
      modalStartDate: false,
      promotion_startDate: '',
      selectDateStart: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      promotion_startTime: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5),
      minTimeStart: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5),

      // เวลาสิ้นสุด
      modalEndDate: false,
      promotion_endDate: '',
      selectDateEnd: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      promotion_endTime: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5),
      minTimeEnd: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5),

      noEndTime: false,
      // กำหนดจำนวนและสิทธิ์
      number: '',
      promotion_available: '',
      promotion_benefit: '',
      promotion_ownBenefit: '',
      promotion_useCount: 0,
      // กลุ่มลูกค้า
      promotion_channel: [],
      channelList: [],

      // Rule
      Rules: {
        name: [
          v => !!v || 'กรุณากรอกข้อมูล',
          v => v.length <= 30 || 'กรุณากรอกข้อมูลไม่เกิน 30 ตัวอักษร'
        ],
        free: [
          v => !!v || 'กรุณากรอกข้อมูล',
          v => parseInt(v) <= parseInt(this.promotion_buy) || 'จำนวนแถมต้องน้อยกว่าหรือเท่ากับจำนวนซื้อ',
          v => v > 0 || 'จำนวนแถมต้องมากกว่า 0'
        ],
        date: [v => !!v || 'กรุณาเลือกวันที่'],
        dateEnd: [
          // v => new Date(v).getTime() > new Date(this.promotion_startDate).getTime() || 'กรุณาเลือกวันที่มากกว่าวันเริ่ม',
          v => new Date(v).getTime() !== new Date(this.promotion_startDate).getTime() || 'กรุณาเลือกวันเวลาที่ไม่ตรงกับวันเริ่ม'
        ],
        promotionBuy: [
          v => !!v || 'กรุณากรอกข้อมูล',
          v => v > 0 || 'จำนวนแถมต้องมากกว่า 0'
        ],
        input: [v => !!v || 'กรุณากรอกข้อมูล'],
        channel: [v => v.length > 0 || 'กรุณาเลือกกลุ่มลูกค้า'],
        limit_amount: [
          v => !!v || 'กรุณากรอกข้อมูล',
          v => parseInt(v) > parseInt(0) || 'จำนวนที่ใช้ได้ต้องมากกว่า 0',
          v => parseInt(v) > parseInt(this.promotion_useCount) || `จำนวนที่ใช้ได้ต้องมากว่าจำนวนที่ถูกใช้ไปแล้ว (ใช้แล้ว ${this.promotion_useCount} )`
        ],
        promotion_ownBenefit: [
          v => !!v || 'กรุณากรอกข้อมูล',
          v => parseInt(v) > parseInt(0) || 'จำนวนที่กรอกต้องมากกว่า 0',
          v => parseInt(v) <= parseInt(this.promotion_available) || `จำนวนที่กรอกต้องน้อยกว่าหรือเท่ากับจำนวนที่ใช้ได้ (จำนวนที่ใช้ได้ ${this.promotion_available} )`
        ]
      }

    }
  },
  watch: {
    MobileSize (val) {
      if (val === false) {
        if (this.status === 'create') {
          this.$router.push({ path: `/Order/ManagePromotion?Status=create&ShopID=${this.seller_shop_id}` }).catch(() => {})
        } else {
          this.$router.push({ path: `/Order/ManagePromotion?PromotionID=${this.promotion_id}&Status=edit&ShopID=${this.seller_shop_id}` }).catch(() => {})
        }
      }
    },
    // ถ้าเลือกไม่มีวันที่ ส่งค่าว่างไป
    date (val) {
      // console.log('date', val)
      if (val === 'no') {
        this.promotion_startDate = ''
        this.selectDateStart = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        this.promotion_startTime = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5)
        this.minTimeStart = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5)
        this.promotion_endDate = ''
        this.selectDateEnd = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        this.promotion_endTime = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5)
        this.minTimeEnd = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5)
        this.noEndTime = false
      }
    },
    // ถ้ากดเลือกวันเริ่มต้นแล้ว
    selectDateStart (val) {
      // ถ้าวันคือวันนี้
      console.log(val)
      if (val === (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)) {
        this.minTimeStart = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(11, 5)
        this.promotion_startTime = this.minTimeStart
      } else {
        this.minTimeStart = ''
        this.promotion_startTime = '00:00'
      }
    },
    selectDateEnd (val) {
      // ถ้าวันคือวันนี้
      console.log(val)
      if (val === (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)) {
        this.promotion_startTime = this.minTimeStart
      } else {
        // this.minTimeEnd = '00:00'
        if (this.promotion_endTime === '') {
          this.promotion_endTime = '00:00'
        }
      }
    },
    number (val) {
      if (val === 'no') {
        this.promotion_available = ''
        this.promotion_benefit = ''
        this.promotion_ownBenefit = ''
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    AllItem () {
      return this.channelList.length === this.promotion_channel.length
    },
    icon () {
      if (this.AllItem) {
        return 'mdi-close-box'
      } else {
        return 'mdi-checkbox-blank-outline'
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      this.seller_shop_id = this.$route.query.ShopID
      this.status = this.$route.query.Status
      // console.log('status', this.status)
      this.checkCanCreate()
      if (this.status === 'create') {
        this.promotion_id = ''
      } else {
        this.promotion_id = this.$route.query.PromotionID
        this.getEditData()
      }
      this.getChannel()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/PromotionMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/Promotion' }).catch(() => {})
      }
    },
    getErrMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง'
      } else if (msg === '') {
        return 'ระบบขัดข้อง กรุณาติดต่อเจ้าหน้าที่'
      }
    },
    checkpromotionBuy () {
      if (parseInt(this.promotion_free) > parseInt(this.promotion_buy)) {
        this.$refs.FormPromotionFree.validate()
      } else {
        this.$refs.FormPromotionFree.resetValidation()
      }
    },
    checkAvilable () {
      if (parseInt(this.promotion_available) >= parseInt(this.promotion_ownBenefit)) {
        if (parseInt(this.promotion_ownBenefit) !== 0) {
          this.$refs.FormPromotionOwnBenefit.resetValidation()
        }
      } else {
        this.$refs.FormPromotionOwnBenefit.validate()
      }
    },
    async checkCanCreate () {
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczCheckCanCreate', data)
      var res = await this.$store.state.ModuleGraczPromotion.stateGraczCheckCanCreate
      if (res.result !== 'SUCCESS') {
        this.$store.commit('closeLoader')
        await this.$swal.fire({ icon: 'warning', text: 'เนื่องจากยังไม่มีกลุ่มลูกค้า จึงไม่สร้างสามารถสร้างโปรโมชันได้', showConfirmButton: false, timer: 3000, toast: true })
        this.$router.push({ path: '/Order/Promotion' })
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        }
      }
    },
    getTime () {
      return (new Date()).getTime() + Math.round(Math.random())
    },
    async getEditData () {
      var data = {
        seller_shop_id: this.seller_shop_id,
        promotion_id: this.promotion_id
      }
      await this.$store.dispatch('actionsGraczPromotionDetail', data)
      var res = await this.$store.state.ModuleGraczPromotionJS.stateGraczPromotionDetail
      // var res = { result: 'SUCCESS' }
      if (res.result === 'success') {
        var promotion = res.data.promotion
        this.DataImage = promotion.promotion_logo
        if (this.DataImage !== '') {
          this.promotion_image.push({
            path: promotion.promotion_logo + '?nochace=' + this.getTime()
          })
        }
        this.promotion_name = promotion.promotion_name
        this.promotion_buy = promotion.minimum_amount
        this.promotion_free = promotion.minimum_free

        // start date
        this.date = promotion.have_timelimit === 'y' ? 'yes' : 'no'
        if (this.date === 'yes') {
          this.promotion_startDate = `${this.formatDate(promotion.start_date.substring(0, 10))} ${promotion.start_date.substring(11, 16)}`
          this.selectDateStart = promotion.start_date.substring(0, 10)
          this.promotion_startTime = promotion.start_date.substring(11, 16)
          this.noEndTime = promotion.end_date === null ? Boolean(true) : Boolean(false)
        }
        // console.log('start date pass')
        // end date
        if (promotion.end_date !== null) {
          this.promotion_endDate = `${this.formatDate(promotion.end_date.substring(0, 10))} ${promotion.end_date.substring(11, 16)}`
          this.selectDateEnd = promotion.end_date.substring(0, 10)
          this.promotion_endTime = promotion.end_date.substring(11, 16)
          if (this.selectDateStart === this.selectDateEnd) {
            // console.log('promotion.start_date', promotion.start_date)
            var hr = promotion.start_date.slice(11, 14)
            var min = parseInt(promotion.start_date.slice(14, 16)) + 1
            var hrm = hr + min.toString()
            this.minTimeEnd = hrm
            console.log('yes', hrm)
          }
        }
        // console.log('end date pass', this.noEndTime)
        // amount
        this.number = promotion.have_limit === 'y' ? 'yes' : 'no'
        // console.log('amount pass', this.number)
        if (this.number === 'yes') {
          this.promotion_available = promotion.limit_amount
          this.promotion_benefit = promotion.access_amount > 1 ? '2' : promotion.access_amount.toString()
          this.promotion_ownBenefit = promotion.access_amount > 1 ? promotion.access_amount.toString() : ''
          this.promotion_useCount = promotion.use_count
        }
        // console.log('amount pass', this.number)
        promotion.group_channel_json.forEach(element => {
          this.promotion_channel.push(element.id)
        })
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var msg
          if (res.result === 'error') {
            msg = this.getErrMsg(res.message)
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          } else {
            msg = this.getErrMsg('')
            console.log(msg)
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          }
        }
      }
      // console.log('this.minTimeEnd', this.minTimeEnd)
      // console.log('data to API search', data)
      // console.log('res from API search', res)
    },
    async getChannel () {
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczListChannel', data)
      var res = await this.$store.state.ModuleGraczChannel.stateGraczListChannel
      if (res.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      this.channelList = res.data.active_channel
      // console.log('channelList', this.channelList)
      // console.log('res from API Channel', res)
    },
    // add pictutre
    onPickFile () {
      document.getElementById('file_input').click()
    },
    UploadImage () {
      const element = this.DataImage
      // ไฟล์รูปภาพเท่านั้น
      console.log(this.promotion_image.length < 1)
      if (this.status !== 'edit') {
        if (this.promotion_image.length < 1) {
          if (element.type === 'image/jpeg' || element.type === 'image/jpg' || element.type === 'image/png') {
            // ขนาดต้องไม่เกิน 2
            const imageSize = element.size / 1024 / 1024
            if (imageSize < 2) {
              var url = URL.createObjectURL(element)
              this.promotion_image.push({
                name: this.DataImage.name,
                path: url
              })
              // console.log(this.promotion_image[0])
            } else {
              this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่รูปที่มีขนาดน้อยกว่า 2 MB', showConfirmButton: false, timer: 1500 })
            }
          } else {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเพิ่มเฉพาะไฟล์รูปภาพ', showConfirmButton: false, timer: 2500 })
          }
        } else {
          this.$swal.fire({ icon: 'warning', text: 'เพิ่มได้ครั้งละ 1 รูปเท่านั้น', showConfirmButton: false, timer: 2500 })
          console.log(this.DataImage)
        }
      } else if (this.status === 'edit') {
        // console.log('edit picture')
        this.promotion_image = []
        console.log(this.DataImage)
        if (this.promotion_image.length < 1) {
          if (element.type === 'image/jpeg' || element.type === 'image/jpg' || element.type === 'image/png') {
            // ขนาดต้องไม่เกิน 2
            const imageSize = element.size / 1024 / 1024
            if (imageSize < 2) {
              var url1 = URL.createObjectURL(element)
              this.promotion_image.push({
                name: this.DataImage.name,
                path: url1
              })
              this.promotion_changeImage = 'y'
              console.log(this.promotion_image)
            } else {
              this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่รูปที่มีขนาดน้อยกว่า 2 MB', showConfirmButton: false, timer: 1500 })
            }
          } else {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเพิ่มเฉพาะไฟล์รูปภาพ', showConfirmButton: false, timer: 2500 })
          }
        } else {
          this.$swal.fire({ icon: 'warning', text: 'เพิ่มได้ครั้งละ 1 รูปเท่านั้น', showConfirmButton: false, timer: 2500 })
          console.log(this.DataImage)
        }
      }
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext
      const draggedElement = draggedContext
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    RemoveImage (index, val) {
      if (this.$route.query.Status === 'Edit') {
        if (val.id !== undefined) {
          this.promotion_image_delete.push(val.id)
        }
        this.promotion_image.splice(index, 1)
      } else {
        this.DataImage = []
        this.promotion_image = []
        this.promotion_changeImage = 'y'
      }
    },
    // save start date
    saveStartDate (startDate, StartTime) {
      // ????
      this.$refs.dialogStartDateKeepCupon.save(startDate)

      var selectDate = new Date(startDate)
      selectDate = this.formatDate(new Date(selectDate.setDate(selectDate.getDate()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))
      this.promotion_startDate = selectDate + ' ' + StartTime

      this.selectDateEnd = startDate
      this.promotion_endTime = '23:59'

      var DateTime = startDate + ' ' + StartTime
      DateTime = new Date(DateTime)
      DateTime = new Date(DateTime.getTime() + (1 * 60000))
      console.log(DateTime)

      // new Date(currentDate.getTime() + minutesToAdd*60000);
      this.minTimeEnd = DateTime.getHours() + ':' + DateTime.getMinutes()
    },
    saveEndDate (endDate, endTime) {
      // ????
      this.$refs.dialogEndDateKeepCupon.save(endDate)

      var selectDate = new Date(endDate)
      selectDate = this.formatDate(new Date(selectDate.setDate(selectDate.getDate()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))
      this.promotion_endDate = selectDate + ' ' + endTime
    },
    formatDate (date) {
      // console.log('format date', date)
      if (!date) return null
      const [year, month, day] = date.split('-')
      return (`${day}/${month}/${year}`)
    },
    selectAllTier () {
      this.$nextTick(() => {
        if (this.AllItem) {
          this.promotion_channel = []
        } else {
          this.promotion_channel = []
          this.channelList.forEach(element => {
            this.promotion_channel.push(element.channel_id)
          })
        }
      })
    },
    save () {
      // console.log(this.DataImage)
      // console.log(`${this.selectDateStart} ${this.promotion_startTime}`)
      if (this.promotion_benefit === '2') {
        if (this.$refs.form.validate(true) && this.$refs.FormPromotionFree.validate(true) && (this.$refs.FormPromotionOwnBenefit.validate(true))) {
          this.sendApiManagePromotion()
        } else {
          this.$nextTick(() => {
            const el = document.getElementsByClassName('error--text')
            if (el) {
              document
                .getElementsByClassName('error--text')[0]
                .scrollIntoView({ behavior: 'smooth', block: 'end' })
            }
          })
        }
      } else {
        if (this.$refs.form.validate(true) && this.$refs.FormPromotionFree.validate(true)) {
          this.sendApiManagePromotion()
        } else {
          this.$nextTick(() => {
            const el = document.getElementsByClassName('error--text')
            if (el) {
              document
                .getElementsByClassName('error--text')[0]
                .scrollIntoView({ behavior: 'smooth', block: 'end' })
            }
          })
        }
      }
    },
    async sendApiManagePromotion () {
      const formData = new FormData()
      formData.append('seller_shop_id', this.seller_shop_id)
      formData.append('promotion_name', this.promotion_name)
      formData.append('promotion_logo', this.DataImage)
      formData.append('minimum_amount', this.promotion_buy)
      formData.append('minimum_free', this.promotion_free)
      formData.append('have_timelimit', this.date === 'yes' ? 'y' : 'n')
      formData.append('start_date', this.date === 'yes' ? `${this.selectDateStart} ${this.promotion_startTime}` : '')
      formData.append('end_date', this.date === 'yes' && this.noEndTime === false ? `${this.selectDateEnd} ${this.promotion_endTime}` : '')
      formData.append('have_limit', this.number === 'yes' ? 'y' : 'n')
      formData.append('limit_amount', this.promotion_available === '' ? 0 : this.promotion_available)
      formData.append('access_amount', this.promotion_benefit !== '2' ? this.promotion_benefit : this.promotion_ownBenefit)
      formData.append('group_channel_json', JSON.stringify(this.promotion_channel))
      if (this.status === 'edit') {
        formData.append('promotion_logo_change', this.promotion_changeImage)
      }

      var res = []
      if (this.status === 'create') {
        await this.$store.dispatch('actionsGraczCreatePromotion', formData)
        res = await this.$store.state.ModuleGraczPromotionJS.stateGraczCreatePromotion
      } else if (this.status === 'edit') {
        formData.append('promotion_id', this.promotion_id)
        await this.$store.dispatch('actionsGraczEditPromotion', formData)
        res = await this.$store.state.ModuleGraczPromotionJS.stateGraczEditPromotion
      }
      // console.log(res)
      if (res.result === 'success') {
        var success = this.status === 'create' ? 'สร้างสำเร็จ' : 'แก้ไขสำเร็จ'
        this.$swal.fire({ icon: 'success', text: success, showConfirmButton: false, timer: 1500 })
        if (this.MobileSize) {
          await this.$router.push({ path: '/Order/PromotionMobile' }).catch(() => {})
        } else {
          await this.$router.push({ path: '/Order/Promotion' }).catch(() => {})
        }
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var msg
          if (res.result === 'error') {
            msg = res.message
            if (msg === 'ข้อมูล access_amount ผิดพลาดกรุณาแก้ไขใหม่') {
              msg = 'ข้อมูล จำนวนที่ใช้ได้ ผิดพลาดกรุณาแก้ไขใหม่'
            } else if (msg === 'promotion_name นี้มีอยู่ในร้านค้านี้แล้ว') {
              msg = 'ชื่อโปรโมชันนี้มีอยู่ในร้านค้านี้แล้ว'
            }
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          } else {
            msg = this.getErrMsg('')
            console.log(msg)
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          }
        }
      }
    },
    CancelSave () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/PromotionMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/Promotion' }).catch(() => {})
      }
    }
  }
}
</script>
<style scoped>
.font10 {
  font-size: 10px; font-weight: 500;  line-height: 14px; color: #9A9A9A;
}
.font14 {
  font-size: 14px; font-weight: 400; line-height: 22px; color: #333333;
}
.font14_500 {
  font-size: 14px; font-weight: 500; line-height: 22px; color: #9A9A9A;
}
.font16_400 {
  font-size: 16px; font-weight: 400; line-height: 24px; color: #333333;
}
.font16 {
  font-size: 16px; font-weight: 700; line-height: 24px; color: #333333;
}

.font18 {
  font-size: 18px; font-weight: 700; line-height: 24px; color: #333333;
}

</style>
